import { Result, Schema, validate } from "nutso";
import { useEffect, useState } from "react";

export const useValidation = <T>(value: T, schema: Schema<T>): Result<T> => {
  console.log(validate(value, schema));
  const [validation, setValidation] = useState<Result<T>>(validate(value, schema));
  useEffect(() => {
    setValidation(validate(value, schema));
  }, [value]);
  return validation;
};
